import { t } from "@/i18n-js/instance";
import { ConfirmationCardLayout } from "./ConfirmationCardLayout";

export interface SpaceGroupConfirmationCardProps {
  member_count?: number;
  name?: string;
}

export const SpaceGroupConfirmationCard = ({
  name,
  member_count,
}: SpaceGroupConfirmationCardProps) => {
  const memberCountText =
    member_count != null
      ? t("help_widget.copilot.confirmation_card.members_count", {
          count: member_count,
        })
      : undefined;

  return (
    <ConfirmationCardLayout
      title={t("help_widget.copilot.confirmation_card.space_group_title")}
      attributes={[
        {
          label: t("help_widget.copilot.confirmation_card.name"),
          value: name,
        },
        {
          label: t("help_widget.copilot.confirmation_card.number_of_members"),
          value: memberCountText,
        },
      ]}
    />
  );
};
